import { RepliersListingPropertyType } from './RepliersListingPropertyType';

export enum DirtyRepliersListingPropertyType {
  'ResidentialITSO' = 'Residential',
  'FreeholdTownhouseITSO' = 'Row/Townhouse',
  'CondoApartmentITSO' = 'Condo/Apt Unit',
  'StoreWithAptOffcITSO' = 'Store with Apt/Office',
  'LandITSO' = 'Land Only',
  'MultiFamilyCREA' = 'Multi Family',
  'SemiDetachedCREA' = 'Semi-detached',
}

export type UnsanitizedRepliersListingPropertyType =
  | RepliersListingPropertyType
  | DirtyRepliersListingPropertyType;
